/* eslint-disable max-len */
export interface ClientClinicHist {
    clinicHistoryDays: ClientClinicHistDay[];
}

export interface ClientClinicHistDay {
    date: string;
    appointments: ClientClinicHistAppointment[];
    pictures: ClientClinicHistServicePicture[];
    forms: ClientClinicHistForm[];
}

export interface ClientClinicHistAppointment {
    id: string;
    services: ClientClinicHistService[];
    clinicAnnotations: ClientClinicHistClinicAnnotation[];
    sketches: ClientClinicHistSketch[]; //Esto viene en un sec diferente?, entonces debe de llegar un booleano para decir si hay o no
}

export interface ClientClinicHistSketch {
    id?: string;
    description: string;
    url: string;
    template?: boolean;
    hasDrawing?: boolean;
    comment?: string;
}

export interface ClientClinicHistService {
    description: string;
    professional: string;
}

export interface ClientClinicHistClinicAnnotation {
    id?: string;
    text?: string;
    previewText?: string;
}

export interface ClientClinicHistServicePicture {
    service: string;
    pictures: ClientClinicHistPicture[]; //Esto viene e un sec diferente? necesitamos entonces la id del servicio de la picture, me tiense que decir que este servicio tiene pictures y que las cargue
}

export interface ClientClinicHistPicture {
    url: string;
    date: string;
    pictureid: string;
    pictureparentid: string;
    serviceid: string;
    comment?: string;
}

export interface ClientClinicHistForm {
    description: string;
    url: string;
}

export interface drawing {
    idSketch: string;
    b64: string;
}

export function createClientClinicHist(
    data: any,
    aesURL: string,
    sessionCookie: string
) {
    const clientClinicHist = {
        clinicHistoryDays: data,
    } as ClientClinicHist;

    //TODO: Eliminamos las apps vacías
    clientClinicHist.clinicHistoryDays.forEach((day) => {
        day.appointments = day.appointments.filter((app) => {
            return app.id !== '';
        });
    });

    clientClinicHist.clinicHistoryDays.forEach((clientClinicHistDay) => {
        clientClinicHistDay.appointments.forEach((appointment) => {
            appointment.sketches.forEach((sketch) => {
                const encodeSubstring = encodeURIComponent(
                    `/cgi-bin/pictures_read.asp?${sketch.url}`
                );
                sketch.url = `${aesURL}&asp=${encodeSubstring}&sessionCookie=${sessionCookie}&contentType=image/jpg`;
            });
        });

        clientClinicHistDay.pictures.forEach((picture) => {
            picture.pictures = picture.pictures.sort((a, b) => {
                const aSplit = a.date.split('/');
                const bSplit = b.date.split('/');
                const aDate = +new Date(parseInt(aSplit[2]), parseInt(aSplit[1]), parseInt(aSplit[0]));
                const bDate = +new Date(parseInt(bSplit[2]), parseInt(bSplit[1]), parseInt(bSplit[0]));

                return aDate - bDate;
            })
            .map((pic) => {
                const encodeSubstring = encodeURIComponent(
                    `/cgi-bin/pictures_read.asp?${pic.url}`
                );
                return {
                    ...pic,
                    url: `${aesURL}&asp=${encodeSubstring}&sessionCookie=${sessionCookie}&contentType=image/jpg`
                }
            });
        });

        clientClinicHistDay.forms.forEach((form) => {
            const encodeSubstring = encodeURIComponent(
                `/cgi-bin/pictures_read.asp?${form.url}`
            );
            form.url = `${aesURL}&asp=${encodeSubstring}&sessionCookie=${sessionCookie}&contentType=application/pdf`;
        });
    });

    return clientClinicHist;
}

export function createCabinetSketches(
    data: any,
    aesURL: string,
    sessionCookie: string
): ClientClinicHistSketch[] {
    const ClientClinicHistSketches = data as ClientClinicHistSketch[];

    ClientClinicHistSketches.forEach((sketch) => {
        if (!sketch.template) {
            const encodeSubstring = encodeURIComponent(
                `/cgi-bin/pictures_read.asp?${sketch.url}`
            );
            sketch.url = `${aesURL}&asp=${encodeSubstring}&sessionCookie=${sessionCookie}&contentType=image/jpg`;
        }
    });

    return ClientClinicHistSketches;
}
